import { useEffect, useMemo, useState } from 'react';
import { ensureIntersectionObserver } from '@src/utils/intersectionObserverPromise';
export const useVisibilityObserver = (element, breakpoint) => {
    const [isVisible, setVisible] = useState(false);
    const observerSettings = {
        threshold: [breakpoint - 0.01, breakpoint, breakpoint + 0.01],
    };
    const [observer, setObserver] = useState(undefined);
    useEffect(() => {
        ensureIntersectionObserver().then(() => {
            setObserver(new IntersectionObserver((entries) => {
                const entry = entries[0];
                const visible = entry.intersectionRatio >= breakpoint;
                if (visible !== isVisible) {
                    setVisible(visible);
                }
                setVisible(visible);
            }, observerSettings));
        });
    }, []);
    useEffect(() => {
        element && observer && observer.observe(element);
        return () => {
            element && observer && observer.unobserve(element);
        };
    }, [element, observer]);
    useEffect(() => {
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [observer]);
    const actions = useMemo(() => {
        return {
            unobserve: () => {
                element && observer && observer.unobserve(element);
            },
        };
    }, [element, observer]);
    return [isVisible, actions];
};
